var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTop3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3566",
    "data-name": "Group 3566",
    transform: "translate(-1094 -228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emoji_events_black_24dp",
    transform: "translate(1094 228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7245",
    "data-name": "Rectangle 7245",
    width: 28,
    height: 28,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5656",
    "data-name": "Path 5656",
    d: "M22.556,5.444H20.111V3H7.889V5.444H5.444A2.452,2.452,0,0,0,3,7.889V9.111a6.1,6.1,0,0,0,5.366,6.038,6.123,6.123,0,0,0,4.412,3.618v3.789H7.889V25H20.111V22.556H15.222V18.767a6.123,6.123,0,0,0,4.412-3.618A6.1,6.1,0,0,0,25,9.111V7.889A2.452,2.452,0,0,0,22.556,5.444ZM5.444,9.111V7.889H7.889v4.669A3.679,3.679,0,0,1,5.444,9.111Zm17.111,0a3.679,3.679,0,0,1-2.444,3.447V7.889h2.444Z",
    transform: "translate(0 0)",
    fill: "#0a859a"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_Text_H6_Selected_On_Surface_High_Emphasis_Left",
    "data-name": "\\u2731 / Text / H6 / Selected / On Surface / High Emphasis / Left",
    transform: "translate(1105 242)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800,
    letterSpacing: "0.033em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop3);
export default __webpack_public_path__ + "static/media/top3.5eb872bbfc7730287d7e79141643f390.svg";
export { ForwardRef as ReactComponent };